import { render, staticRenderFns } from "./ProcessOrderSwitch.vue?vue&type=template&id=35a5a343&scoped=true&lang=html&"
import script from "./ProcessOrderSwitch.vue?vue&type=script&lang=js&"
export * from "./ProcessOrderSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ProcessOrderSwitch.vue?vue&type=style&index=0&id=35a5a343&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a5a343",
  null
  
)

export default component.exports